var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.541571 1.67492C2.2249 3.83325 5.33324 7.83325 5.33324 7.83325V12.8333C5.33324 13.2916 5.70824 13.6666 6.16657 13.6666H7.83324C8.29157 13.6666 8.66657 13.2916 8.66657 12.8333V7.83325C8.66657 7.83325 11.7666 3.83325 13.4499 1.67492C13.8749 1.12492 13.4832 0.333252 12.7916 0.333252H1.1999C0.508238 0.333252 0.116571 1.12492 0.541571 1.67492Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlack);
export default __webpack_public_path__ + "static/media/filter-black.e1f6486cd5baa40a575aa38cb447bac9.svg";
export { ForwardRef as ReactComponent };